const { default: def } = require("ajv/dist/vocabularies/applicator/additionalItems");

const supportedLocales = {
    GB: {
        currency: "GBP",
        currencySymbol: "£",
    },
    US: {
        currency: "USD",
        currencySymbol: "$"
    },
    AU: {
        currency: "AUD",
        currencySymbol: "$"
    }
};

const getCurrency = (countryCode) => {
    let locale = supportedLocales[countryCode];
    if (locale == null) {
        return supportedLocales.GB.currency;
    } else {
        return locale.currency;
    }
}


 const getCurrencySymbol = (countryCode) => {
    let locale = supportedLocales[countryCode];
    if (locale == null) {
        return supportedLocales.GB.currencySymbol;
    } else {
        return locale.currencySymbol;
    }
}

const getGamePricing = (countryCode, game) => {
    let pricing = game.pricing[countryCode.toLowerCase()];
    if (pricing == null) {
        return game.pricing.gb;
    } else {
        return pricing
    }
}

export default {
    getCurrency,
    getCurrencySymbol,
    getGamePricing
}